const fmt = (d) => new Date(d).toLocaleDateString("fr-FR");

export const accessState = (r) => {
  if (r.last_login_at) return { key: "active", label: `Connecté le ${fmt(r.last_login_at)}`, cls: "bg-emerald-50 text-emerald-800 border-emerald-200" };
  if (r.password_set_at) return { key: "pwd", label: "Mot de passe choisi, jamais connecté", cls: "bg-amber-50 text-amber-800 border-amber-200" };
  if (r.invite_status === "failed") return { key: "failed", label: "Échec de l'invitation", cls: "bg-red-50 text-red-700 border-red-200" };
  if (r.invited_at) return { key: "invited", label: `Invité le ${fmt(r.invited_at)}, mot de passe non choisi`, cls: "bg-sky-50 text-sky-800 border-sky-200" };
  return { key: "none", label: "Jamais invité ni connecté", cls: "bg-muted text-muted-foreground border-border" };
};

export const sendState = (r) => (r.invite_status === "failed" ? "failed" : r.invited_at ? "sent" : "never");

export const SEND_FILTERS = [["all", "Tous les envois"], ["sent", "Accès envoyé"], ["failed", "Échec d'envoi"], ["never", "Accès jamais envoyé"]];


export const ACCESS_FILTERS = [
  ["all", "Tous les accès"], ["active", "Déjà connectés"], ["pwd", "Mot de passe choisi, jamais connectés"],
  ["invited", "Invités, mot de passe non choisi"], ["failed", "Échec de l'invitation"], ["none", "Jamais invités"],
];

export const AccessBadge = ({ r }) => {
  const s = accessState(r);
  return <span className={`inline-block text-[11px] leading-tight px-2 py-0.5 rounded-full border ${s.cls}`} data-testid={`access-status-${r.email}`}>{s.label}</span>;
};
